import { CustomError } from '@/model/CustomError';
import { AxiosError } from 'axios';

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const err = error as AxiosError<CustomError>;
    let message = '';
    if (err && err.response && err.response.data) {
      if (err.response.data.details && err.response.data.details.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        message = err.response.data.details[0];
      } else if (err.response.data.message) {
        message = err.response.data.message;
      }
    }

    return message;
  }
  return '';
};
